import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyBiS8nBrjcvDVLfz13aUDjvBIUeWH99hsA",
    authDomain: "clone-project-6d0ef.firebaseapp.com",
    projectId: "clone-project-6d0ef",
    storageBucket: "clone-project-6d0ef.appspot.com",
    messagingSenderId: "648546196925",
    appId: "1:648546196925:web:a8b67f69448bb4165546d4",
    measurementId: "G-SHR2HXGKSM"
  };


const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };